import { useQuery } from '@tanstack/react-query';
import { ModuleHeader } from '@/components/ui/module-header';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { StatusPill } from '@/components/ui/status-pill';
import { api } from '@/lib/api';

export default function SuperAppsPage() {
  const q = useQuery({
    queryKey: ['super-apps'],
    queryFn: async () => {
      const r = await api('/api/v1/super/apps');
      if (r.status !== 200) throw new Error('apps');
      return r.data;
    },
  });
  const apps = q.data?.apps ?? [];

  return (
    <div className="space-y-6 motion-enter">
      <ModuleHeader
        title="Apps catalog"
        description="Incoming / beta / GA registry shared with marketing. Flip status when integrations ship."
        icon="AppWindow"
        metrics={[
          { label: 'Total', value: apps.length || '—' },
          {
            label: 'Incoming',
            value: apps.filter((a) => a.status === 'incoming').length || '—',
          },
          { label: 'GA', value: apps.filter((a) => a.status === 'ga').length || '—' },
        ]}
      />

      <Card>
        <CardHeader>
          <CardTitle>Catalog</CardTitle>
        </CardHeader>
        <CardContent>
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-muted-foreground border-b">
                <th className="py-2 pr-3">App</th>
                <th className="py-2 pr-3">Status</th>
                <th className="py-2 pr-3">Placement</th>
                <th className="py-2 pr-3">Price</th>
                <th className="py-2">Summary</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {apps.map((app) => (
                <tr key={app.id}>
                  <td className="py-3 pr-3 font-medium">{app.name}</td>
                  <td className="py-3 pr-3">
                    <StatusPill status={app.status === 'ga' ? 'active' : 'pending'} />
                    <span className="ml-2 text-xs text-muted-foreground">{app.status}</span>
                  </td>
                  <td className="py-3 pr-3 font-mono text-xs">{app.placement}</td>
                  <td className="py-3 pr-3 font-mono data-text">
                    {app.priceMonthly == null ? 'Included' : `$${app.priceMonthly}/mo`}
                  </td>
                  <td className="py-3 text-muted-foreground">{app.summary}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>
  );
}
